module.exports = __webpack_public_path__ + "img/2.b60d25bf.png";